export default {
  vision_save__:
    "Vision saves you weeks and months of digging through forums, chats, channels, and blogs.".toUpperCase(),
  say_goodbuy__:
    "Say goodbye to outdated 2012 forum designs and sites run by people who are out of touch with the community.".toUpperCase(),
  top_projects: "top projects".toUpperCase(),

  lorem_ipsum__: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.".toUpperCase(),
};
